import axios from 'axios'
import config from '../../config/index.js'

const HTTP = axios.create({
  baseURL: config.baseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTP.interceptors.request.use(function (config) {
  if (config) {
    config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('jwt')
    return config
  }
}, function (error) {
  return Promise.reject(error)
})

export default {
  /* GET */
  _get (_url) {
    return HTTP.get(_url)
  },
  /* DELETE */
  _delete (_url) {
    return HTTP.delete(_url)
  },
  /* POST */
  _post (_url) {
    return HTTP.post(_url, {})
  },
  postLogin (_url, _pnr, _cb) {
    return HTTP.post(_url, {
      personalId: _pnr,
      callbackUrl: _cb
    })
  },
  postToken (_url, _sessionId) {
    return HTTP.post(_url, {
      sessionID: _sessionId
    })
  },
  postTokenTest (_url, _temp) {
    return HTTP.post(_url, {
      personalId: _temp.ssn,
      givenName: _temp.firstname,
      surName: _temp.lastname
    })
  },
  postConsent (_url, _consent, _research, _pharmacy) {
    return HTTP.post(_url, {
      consent: _consent,
      consentResearchData: _research,
      pharmacy: _pharmacy
    })
  },
  postConsentPath (_url, _path, _medication, _phoneNumber) {
    return HTTP.post(_url, {
      serviceChoice: _path,
      medication: _medication,
      phoneNumber: _phoneNumber
    })
  },
  postVerifyPhone (_url, _phoneNumber, _code) {
    return HTTP.post(_url, {
      phoneNumber: _phoneNumber,
      code: _code
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js